import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { IGetState } from '../../../../../types/types';
import { fetchHandler } from '../../../../../util/fetchHandler';
import { REST_CHATS } from '../../../../constants';
import { getRestHeadersGet } from '../../../../helpers/getRestHeadersHelper';
import { Util } from '../../../../../util/util';
import { IChatGroup } from '../types';

/***
 * Загружаем чат группы для текущего пользователя
 */
export const getChatGroups = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        return fetchHandler<IChatGroup[]>(
            Util.getApiUrl(
                REST_CHATS + 'groups'),
                getRestHeadersGet(),
        );
    };
    return action;
};
